export default __webpack_public_path__ + "static/media/app-sectors-dark.4505ccc2.png";